// initialed state
export const initialState = () => ({
	openDialogs: [],
	openingDialog: false,
	// state.isDialogActive used by UserMatchingMixin only,
	// go to `$data._userMatchingDialog` watch in UserMatchingMixin before extending the use of if.
	// probably if you want to use it to another use case, you should do it through AppDialogManager
	// it's here to allow manually mark as there is opened dialog, even though it wasn't open from dialogs store module
	isDialogActive: false,
});

const state = initialState();

export default state;
